import { render, staticRenderFns } from "./RuleAuditLog.vue?vue&type=template&id=b78c6844"
import script from "./RuleAuditLog.vue?vue&type=script&lang=js"
export * from "./RuleAuditLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports